import { connect } from 'react-redux'
import {
  getRdwStockFilters,
  getRdwStockResults,
  updateRdwItem,
} from 'redux/actions/data'
import RdwStockView from '../views/rdw-stock-view'

const mapStateToProps = ({ data }) => ({
  rdwStockFilters: data.rdwStockFilters,
  rdwStockResults: data.rdwStockResults,
  rdwItemUpdate: data.rdwItemUpdate,
})

const mapDispatchToProps = {
  getRdwStockFilters,
  getRdwStockResults,
  updateRdwItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(RdwStockView)
